export interface DetectBrowserInfo {
	android?: {
		osVersion?: number
		browserVersion?: number
	},
	iOS?: {},
	webkit?: {},
	iOSSafari?: {},
}

/**
 * Minimal browser detection and addition of data-* attributes to a given
 * element based on detection.
 */
class DetectBrowser {
	private info?: DetectBrowserInfo;

	getInfo(): DetectBrowserInfo {
		if (this.info === undefined) {
			let info: DetectBrowserInfo = {};

			let ua = navigator.userAgent;
	
			let androidMatch = /android\s([\d.]*).+version\/\s*([\d.]*)/ig.exec(ua);
			if (androidMatch !== null && !/(chrome|iemobile)/ig.test(ua)) {
				info.android = {
					osVersion: androidMatch[1] === undefined ? undefined : parseFloat(androidMatch[1]),
					browserVersion: androidMatch[2] === undefined ? undefined : parseFloat(androidMatch[2])
				};
			}
			
			if (!!ua.match(/iPad/i) || !!ua.match(/iPhone/i)) {
				info.iOS = {};
			}
			if (!!ua.match(/WebKit/i)) {
				info.webkit = {};
			}
			if (info.iOS !== undefined && info.webkit !== undefined && !ua.match(/CriOS/i)) {
				info.iOSSafari = {};
			}

			this.info = info;
		}
		return this.info;
	}
	
	addStyleClasses(element: HTMLElement): void {
		let info = this.getInfo();
		
		if (info.android) {
			element.setAttribute('data-browser', 'android');
			element.setAttribute('data-osversion', String(info.android.osVersion));
			element.setAttribute('data-browserversion', String(info.android.browserVersion));
		}
		if (info.iOSSafari) {
			element.setAttribute('data-os', 'iOS');
			element.setAttribute('data-browser', 'Safari');
		}
	}
}

export default new DetectBrowser();
